import { ApiProperty } from "@nestjs/swagger";

export class WorkStationCategoryRequest{
    @ApiProperty()
    workstationCategory:number;
    @ApiProperty()
    unitId?:number;
}